<template>
  <div class="deleteFang padding20">
    <div class="row-me">
      <div>{{ title ? title : '作废原因' }}：</div>
      <div class="flex1">
        <el-input :placeholder="'请输入'+title" type="textarea" style="width: 100%;" clearable
                  :class="{'red-border':showRedBorder&&(content===''||content===null)}" v-model="content"
                  maxlength="500" show-word-limit autosize>
        </el-input>
      </div>
    </div>
    <div class="row-me row-center flex-end1 margin-top100">
      <div class="btn-blank width140 btn-height40" @click="clickCancel">取消</div>
      <el-button type="primary" class="width140" :disabled="isSaving" @click="clickSave">提交</el-button>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    ids: {
      type: Array,
      default: () => [],
    },
    //页面来源
    source: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      content: '',
      showRedBorder: false,
      isSaving: false,
    }
  },
  // html加载完成之前
  created() {

  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    clickSave() {
      this.isSaving = true
      if (this.content === '' || this.content === null) {
        this.showRedBorder = true
        this.isSaving = false
        return
      }
      if (this.source === '接方') {
        this.$postFormRequest('/admin/order/receive', {
          ids: this.ids,
          pass: false,
          reason: this.content
        }).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.bus.$emit('deleteFangSuccess', 'refresh')
          }
        }).catch((error) => {
          this.isSaving = false
          console.log(error)
        })
      } else if (this.source === '审方') {
        this.$postRequest('/admin/order/check', {
          ids: this.ids,
          pass: false,
          reason: this.content
        }).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.bus.$emit('deleteFangSuccess', 'refresh')
          }
        }).catch((error) => {
          console.log(error)
          this.isSaving = false
        })
      } else if (this.source === '调剂') {
        this.$postFormRequest('/admin/order/tiaojiFinish', {
          ids: this.ids,
          type: 0,//0驳回，1完成
          remark: this.content
        }).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.bus.$emit('deleteFangSuccess', 'refresh')
          }
        }).catch((error) => {
          this.isSaving = false
          console.log(error)
        })
      } else if (this.source === '复核') {
        this.$postFormRequest('/admin/order/fuheFinish', {
          ids: this.ids,
          type: 0,//0驳回，1完成
          remark: this.content
        }).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.bus.$emit('deleteFangSuccess', 'refresh')
          }
        }).catch((error) => {
          console.log(error)
          this.isSaving = false
        })
      }
    },
    clickCancel() {
      this.bus.$emit('deleteFangSuccess')
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
}
</script>

<style lang="scss" scoped>
.deleteFang {
  &:deep(.el-textarea__inner) {
    height: 150px;
  }
}
</style>
